import axios from 'axios'

import { parseError } from '../../../helpers'

const INITIAL_STATE = {
  error: false,
  isLoaded: false,
  items: [],
}

const FETCH_COLOURS = 'FETCH_COLOURS'
const POPULATE_COLOURS = 'POPULATE_COLOURS'
const SET_COLOURS_ERROR = 'SET_COLOURS_ERROR'

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COLOURS:
      return {
        ...state,
        items: [],
        isLoaded: false,
      }
    case POPULATE_COLOURS:
      return {
        ...state,
        items: action.payload,
        isLoaded: true,
      }
    case SET_COLOURS_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoaded: true,
      }
    default:
      return state
  }
}

export const fetchColoursAction = () => async dispatch => {
  try {
    dispatch({ type: SET_COLOURS_ERROR, payload: false })
    dispatch({ type: FETCH_COLOURS })
    const response = await axios.get('/getColours')
    // console.log(response.data)
    dispatch({
      type: POPULATE_COLOURS,
      payload: response.data,
    })
  } catch (e) {
    dispatch({
      type: SET_COLOURS_ERROR,
      payload: parseError(`fetchColoursAction - ${parseError(e)}`),
    })
  }
}

export default reducer
